// ============================================
// FILE: src/pages/admin/Users.jsx
// ============================================
import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import Navbar from '../../components/Navbar';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/users`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUsers(data.users || []);
      } else {
        console.log('API error:', response.status, response.statusText);
        setUsers([]);
        toast.error('Failed to load users');
      }
    } catch (error) {
      console.error('Users fetch error:', error);
      setUsers([]);
      toast.error('Network error - check backend connection');
    }
    setLoading(false);
  };

  const toggleActive = async (userId, currentStatus) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/users/${userId}/toggle`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        toast.success(`User ${currentStatus ? 'deactivated' : 'activated'}`);
        fetchUsers();
      } else {
        toast.error('Failed to update user status');
      }
    } catch (error) {
      toast.error('Error updating user status');
    }
  };

  return (
    <div className="min-h-screen bg-cover bg-center bg-fixed" style={{ backgroundImage: "url('/images/trade-bg.jpg')" }}>
      <div className="min-h-screen bg-black/40 w-full pb-10">
        <Navbar userType="admin" />

        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Manage Users</h1>

            {loading ? (
              <div className="text-center py-12">Loading users...</div>
            ) : (
              <div className="bg-white shadow overflow-hidden sm:rounded-md">
                <ul className="divide-y divide-gray-200">
                  {users.map((user) => (
                    <li key={user.id} className="px-6 py-4">
                      <div className="flex items-center justify-between">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center">
                            <div className="flex-1 min-w-0">
                              <p className="text-lg font-medium text-gray-900 truncate">
                                {user.name || 'Unnamed User'}
                              </p>
                              <p className="text-sm text-gray-600 truncate">
                                {user.email || 'No email'} • Phone: {user.phone}
                              </p>
                              <p className="text-sm text-gray-500">
                                Joined: {new Date(user.created_at).toLocaleDateString()} • Total Orders: {user.total_orders || 0}
                              </p>
                              <div className="flex items-center space-x-4 mt-2">
                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${user.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                  }`}>
                                  {user.is_active ? 'Active' : 'Inactive'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="ml-4 flex-shrink-0 flex space-x-2">
                          <button
                            onClick={() => toggleActive(user.id, user.is_active)}
                            className={`text-sm px-3 py-1 border rounded hover:bg-opacity-50 ${user.is_active
                              ? 'text-red-600 border-red-600 hover:bg-red-50'
                              : 'text-green-600 border-green-600 hover:bg-green-50'
                              }`}
                          >
                            {user.is_active ? 'Deactivate' : 'Activate'}
                          </button>
                          <button className="text-blue-600 hover:text-blue-900 text-sm px-3 py-1 border border-blue-600 rounded hover:bg-blue-50">
                            View Details
                          </button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;